import React, { useState, useEffect } from 'react';
import { ExclamationTriangleIcon, CheckCircleIcon, XMarkIcon } from '@heroicons/react/24/outline';

export default function ConfigurationCheck() {
  const [showWarnings, setShowWarnings] = useState(false);
  const [configStatus, setConfigStatus] = useState({
    stripe: false,
    firebase: false,
    email: false,
    missingVars: []
  });

  useEffect(() => {
    checkConfiguration();
  }, []);

  const checkConfiguration = () => {
    const missingVars = [];
    
    // Check Stripe configuration
    const stripeVars = [
      'REACT_APP_STRIPE_PUBLIC_KEY',
      'REACT_APP_STRIPE_STARTER_PRICE_ID',
      'REACT_APP_STRIPE_GROWTH_PRO_PRICE_ID',
      'REACT_APP_STRIPE_ENTERPRISE_PRICE_ID'
    ];
    
    const stripeConfigured = stripeVars.every(varName => {
      const value = process.env[varName];
      // || value.includes('test_')
      if (!value || value.includes('your_') ) {
        missingVars.push(varName);
        return false;
      }
      return true;
    });

    // Check Firebase configuration
    const firebaseVars = [
      'REACT_APP_FIREBASE_API_KEY',
      'REACT_APP_FIREBASE_AUTH_DOMAIN',
      'REACT_APP_FIREBASE_PROJECT_ID'
    ];
    
    const firebaseConfigured = firebaseVars.every(varName => {
      const value = process.env[varName];
      if (!value || value.includes('your_')) {
        missingVars.push(varName);
        return false;
      }
      return true;
    });

    // Check Email configuration
    const emailVars = [
      'REACT_APP_EMAILJS_SERVICE_ID',
      'REACT_APP_EMAILJS_TEMPLATE_ID',
      'REACT_APP_EMAILJS_PUBLIC_KEY'
    ];
    
    const emailConfigured = emailVars.every(varName => {
      const value = process.env[varName];
      if (!value || value.includes('your_')) {
        missingVars.push(varName);
        return false;
      }
      return true;
    });

    setConfigStatus({
      stripe: stripeConfigured,
      firebase: firebaseConfigured,
      email: emailConfigured,
      missingVars
    });

    // Show warnings if any configuration is missing
    if (!stripeConfigured || !firebaseConfigured || !emailConfigured) {
      setShowWarnings(true);
    }
  };

  if (!showWarnings) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-50 max-w-md">
      <div className="bg-yellow-50 border border-yellow-300 rounded-lg shadow-lg p-4">
        <div className="flex items-start">
          <ExclamationTriangleIcon className="h-5 w-5 text-yellow-600 mt-0.5 mr-3 flex-shrink-0" />
          <div className="flex-1">
            <h3 className="text-sm font-medium text-yellow-800 mb-2">
              Configuration Required
            </h3>
            <div className="text-sm text-yellow-700 space-y-1">
              {!configStatus.stripe && (
                <div className="flex items-center">
                  <XMarkIcon className="h-4 w-4 text-red-500 mr-2" />
                  <span>Stripe billing not configured</span>
                </div>
              )}
              {!configStatus.firebase && (
                <div className="flex items-center">
                  <XMarkIcon className="h-4 w-4 text-red-500 mr-2" />
                  <span>Firebase not configured</span>
                </div>
              )}
              {!configStatus.email && (
                <div className="flex items-center">
                  <XMarkIcon className="h-4 w-4 text-red-500 mr-2" />
                  <span>Email service not configured</span>
                </div>
              )}
            </div>
            <div className="mt-3">
              <a
                href="/ENVIRONMENT_SETUP.md"
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-yellow-800 underline hover:text-yellow-900"
              >
                View setup instructions
              </a>
            </div>
          </div>
          <button
            onClick={() => setShowWarnings(false)}
            className="ml-3 text-yellow-600 hover:text-yellow-800"
          >
            <XMarkIcon className="h-4 w-4" />
          </button>
        </div>
      </div>
    </div>
  );
} 